import { Popup, type PopupProps } from '@atlaskit/popup';
import { withChoreographedRender } from '@atlassian/jira-choreographer-services/src/withChoreographedRender.tsx';

export const ChoreographerPopup = withChoreographedRender<PopupProps>(Popup, {
	toggleableProp: 'isOpen',
});
